import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ViewProjectsListModule"
const debug = false

export class ViewProjectsListModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_PROJECTS_LIST, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Projects List"
        this.description                = ""
        this.svgIcon                    = "isvg-view-projects-list"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Views"
        this.settingsUrl                = "settings/view-projects-list"
        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false
        this.parentSection              = SettingsParentSection.VIEWS

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}
